const config = {
  development: {
    CLIENT_ID: 'AbrATdqT8ut-swJqF0jbiPjwPpScAk4ikxweAusxr7KVtVaB0YpiQpZ0Bt1y7ENvMPIGbIWi8cPcrWh5',
  },
  staging: {
    CLIENT_ID: 'AbrATdqT8ut-swJqF0jbiPjwPpScAk4ikxweAusxr7KVtVaB0YpiQpZ0Bt1y7ENvMPIGbIWi8cPcrWh5',
  },
  production: {
    CLIENT_ID: 'AQvY1jd9yps5SvRDFoRbf1-vyQXuI7vTBpxub4KDv0yLRF8vZucwS_RMbBNIKHrgEqp1ky-PEp5xdiEs',
  },
};

export default config;
